module.exports = __webpack_public_path__ + "static/media/Welcome.cef01c99.jpg";